<template>
  <div>
    <b-card class="m-3">
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold">Cadastro de Suspensão de Advogados</span>
        </h6>
      </template>
      <div class="accordion" role="tablist">

        <b-card no-body>
          <b-card-header header-tag="header" role="tab">
            <div>
              <h6 class="my-auto" style="text-align: left" v-b-toggle.accordion-1>
                <font-awesome-icon icon="plus" class="mr-2" />Cadastrar nova suspensão
              </h6>
            </div>
          </b-card-header>

          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <b-form @submit.stop.prevent="cadastrarSuspensao">
                <b-row>
                  <b-col cols="12" md="6" xl="4">
                    <b-form-group id="input-group-cpf" label="CPF *" label-for="input-cpf" label-class="text-left">
                      <b-form-input id="input-cpf" v-model="novaSuspensao.cpf" type="text"
                        @blur="buscarAdvogadoPorCpf(novaSuspensao.cpf, 'criar')" maxlength="11"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <b-form-group id="input-group-nome" label="Nome *" label-for="input-nome" label-class="text-left">
                      <b-form-input id="input-nome" v-model="novaSuspensao.nome" type="text"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <b-form-group id="input-group-nrOab" label="Nº OAB *" label-for="input-nrOab"
                      label-class="text-left">
                      <b-form-input id="input-nrOab" v-model="novaSuspensao.oab" type="text"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <b-form-group id="dataInicioSuspensao" label="Data de Início da Suspensão *"
                      label-for="input-dataInicioSuspensao" label-class="text-left" class="datepicker-sagres">
                      <b-form-datepicker id="input-dataInicioSuspensao" v-model="novaSuspensao.inicioSuspensao"
                        placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                        label-help="Use as setas para navegar pelas datas" label-prev-year="Ano anterior"
                        label-prev-month="Mês anterior" label-current-month="Mês atual" label-next-month="Próximo mês"
                        label-next-year="Próximo ano" label-reset-button="Limpar"
                        reset-button-variant="outline-secondary" reset-button></b-form-datepicker>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <b-form-group id="dataFimSuspensao" label="Data de Término da Suspensão"
                      label-for="input-dataFimSuspensao" label-class="text-left" class="datepicker-sagres">
                      <b-form-datepicker id="input-dataFimSuspensao" v-model="novaSuspensao.fimSuspensao"
                        placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                        label-help="Use as setas para navegar pelas datas" label-prev-year="Ano anterior"
                        label-prev-month="Mês anterior" label-current-month="Mês atual" label-next-month="Próximo mês"
                        label-next-year="Próximo ano" label-reset-button="Limpar"
                        reset-button-variant="outline-secondary" reset-button></b-form-datepicker>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" md="6" xl="4">
                    <b-form-group id="observacao" label="Observação" label-for="input-observacao"
                      label-class="text-left">
                      <b-form-textarea id="input-observacao" v-model="novaSuspensao.observacao" rows="3" max-rows="6">
                      </b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" class="pt-4">
                    <b-button size="sm" variant="secondary" class="mr-2" type="submit"
                      :disabled="!novaSuspensaoPreenchida">
                      <font-awesome-icon icon="save" class="mr-2" />
                      Cadastrar Suspensão
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </b-card>
    <b-card class="m-3">
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="font-weight-bold">Suspensões Cadastradas</span>
        </h6>
      </template>
      <b-table :busy="isBusy" :fields="fields" hover no-border-collapse :items="items" :sort-desc="true" striped small
        :per-page="perPage" :current-page="currentPage" show-empty stacked="md">
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <div v-if="false">
            <span class="">{{}}</span>
          </div>
          <div v-else class="actions-icons">
            <div class="wrapper-icon" @click="abrirModalDetalhes(row.item)">
              <font-awesome-icon icon="eye" />
              <div style="font-size: 12px">Detalhes</div>
            </div>
            <div class="wrapper-icon" @click="abrirModalEdicao(row.item.IdSuspensao)">
              <font-awesome-icon icon="edit" />
              <div style="font-size: 12px">Editar</div>
            </div>
            <btn-excluir :idItem="row.item.IdSuspensao" :excluirItem="excluirSuspensao" />
          </div>
        </template>
      </b-table>
      <table-pagination v-if="totalRows" :total-rows="totalRows" :per-page="perPage" @pageChange="pageChange">
      </table-pagination>
    </b-card>
    <b-modal id="edit-modal" size="xl" button-size="sm" centered header-bg-variant="secondary"
      header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop no-close-on-esc
      hide-footer>
      <template v-slot:modal-header="">
        <h5>Editar Suspensão</h5>
      </template>
      <b-form @submit.stop.prevent="editarSuspensao">
        <b-row>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-cpf" label="CPF *" label-for="input-cpf" label-class="text-left">
              <b-form-input id="input-cpf" v-model="suspensaoEditar.cpf" type="text"
                @blur="buscarAdvogadoPorCpf(suspensaoEditar.cpf, 'editar')" maxlength="11"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-nome" label="Nome *" label-for="input-nome" label-class="text-left">
              <b-form-input id="input-nome" v-model="suspensaoEditar.nome" type="text"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="input-group-nrOab" label="Nº OAB *" label-for="input-nrOab" label-class="text-left">
              <b-form-input id="input-nrOab" v-model="suspensaoEditar.oab" type="text"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="dataInicioSuspensao" label="Data de Início da Suspensão *"
              label-for="input-dataInicioSuspensao" label-class="text-left">
              <b-form-datepicker id="input-dataInicioSuspensao" v-model="suspensaoEditar.inicioSuspensao"
                placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                label-help="Use as setas para navegar pelas datas" label-prev-year="Ano anterior"
                label-prev-month="Mês anterior" label-current-month="Mês atual" label-next-month="Próximo mês"
                label-next-year="Próximo ano" label-reset-button="Limpar" reset-button-variant="outline-secondary"
                reset-button></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="dataFimSuspensao" label="Data de Término da Suspensão" label-for="input-dataFimSuspensao"
              label-class="text-left">
              <b-form-datepicker id="input-dataFimSuspensao" v-model="suspensaoEditar.fimSuspensao"
                placeholder="Selecione uma data" value-as-date label-no-date-selected="Nenhuma data selecionada"
                label-help="Use as setas para navegar pelas datas" label-prev-year="Ano anterior"
                label-prev-month="Mês anterior" label-current-month="Mês atual" label-next-month="Próximo mês"
                label-next-year="Próximo ano" label-reset-button="Limpar" reset-button
                reset-button-variant="outline-secondary"></b-form-datepicker>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="6" xl="4">
            <b-form-group id="observacao" label="Observação" label-for="input-observacao" label-class="text-left">
              <b-form-textarea id="input-observacao" v-model="suspensaoEditar.observacao" rows="3" max-rows="6">
              </b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="pt-4 d-flex justify-content-end">
            <b-button size="sm" class="mr-3" type="submit" :disabled="!suspensaoEditarPreenchida">
              Salvar Alterações
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="fecharModalEdicao()">
              Cancelar
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <b-modal id="details-modal" size="lg" button-size="sm" centered header-bg-variant="secondary"
      header-text-variant="light" header-class="" footer-class="" modal-class="p-2" no-close-on-backdrop
      no-close-on-esc>
      <template v-slot:modal-header="">
        <h5>Detalhes da Suspensão</h5>
      </template>
      <span><strong>CPF: </strong>{{ suspensaoDetalhes.cpf }}</span><br />
      <span><strong>Nome: </strong>{{ suspensaoDetalhes.nome }}</span><br />
      <span><strong>Nº OAB: </strong>{{ suspensaoDetalhes.oab }}</span><br />
      <span><strong>Período de Suspensão: </strong>{{ suspensaoDetalhes.periodoSuspensao }}</span><br />
      <span><strong>Observação: </strong></span>
      <div style="max-width: 100%; word-wrap: break-word;">{{ suspensaoDetalhes.observacao }}</div>
      <template v-slot:modal-footer="">
        <b-button variant="outline-secondary" @click="fecharModalDetalhes()">
          Fechar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import suspensaoAdvogadoService from '@/services/suspensaoAdvogadoService'
import TablePagination from "@/components/atos-pessoal/TablePagination.vue";
import BtnExcluir from "@/components/shared/btn-excluir.vue"
import { UtilsTS } from '@/utilsts';

export default {
  name: "cadastro-suspensao-advogados",
  mixins: [UtilsTS],
  components: {
    TablePagination,
    BtnExcluir
  },
  data() {
    return {
      novaSuspensao: {
        cpf: null,
        nome: null,
        oab: null,
        inicioSuspensao: null,
        fimSuspensao: null,
        observacao: null,
      },
      suspensaoEditar: {
        cpf: null,
        nome: null,
        oab: null,
        inicioSuspensao: null,
        fimSuspensao: null,
        observacao: null,
      },
      suspensaoDetalhes: {
        cpf: null,
        nome: null,
        oab: null,
        periodoSuspensao: null,
        observacao: null,
      },
      perPage: 10,
      currentPage: 1,
      totalRows: null,
      isBusy: true,
      fields: [
        {
          key: "IdSuspensao",
          label: "Id",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: false,
        },
        {
          key: "Cpf",
          label: "CPF",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "Nome",
          label: "Nome",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "Oab",
          label: "Nº OAB",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "PeriodoSuspensao",
          label: "Período de Suspensão",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "Observacao",
          label: "Observação",
          tdClass: "d-none",
          thClass: "d-none",
          sortable: true,
        },
        {
          key: "actions",
          label: "Ações",
          tdClass: ["align-middle", "col-actions"],
          thClass: "text-center",
          sortable: true,
        },
      ],
      items: [],
      confirmarExclusao: null,
      usuarioEncontradoMsg: '',
    };
  },
  filters: {
    date(date) {
      return date ? date.toLocaleDateString("pt-BR") : "";
    },
  },
  methods: {
    async habilitarBtnExclusao(idSuspensao) {
      this.confirmarExclusao = idSuspensao
      await new Promise(resolve => setTimeout(resolve, 5000));
      this.confirmarExclusao = null
    },

    async pageChange(value) {
      this.currentPage = value;
    },
    async cadastrarSuspensao() {
      this.novaSuspensao.inicioSuspensao.setHours(0);
      this.novaSuspensao.inicioSuspensao.setMinutes(0);
      this.novaSuspensao.inicioSuspensao.setSeconds(0);
      if (this.novaSuspensao.fimSuspensao != null) {
        this.novaSuspensao.fimSuspensao.setHours(23);
        this.novaSuspensao.fimSuspensao.setMinutes(59);
        this.novaSuspensao.fimSuspensao.setSeconds(59);
      }
      const response = await suspensaoAdvogadoService.cadastrarSuspensao(this.novaSuspensao)
      if (response && response.status == 200) {
        await this.loadData()
        this.$toast.success("Suspensão cadastrada com sucesso")
      }
      else if (response && response.status == 400) {
        response.data.erros.forEach(erro => {
          this.$toast.error(erro, {
            timeout: 10000
          })
        });
      }
      else {
        this.$toast.error("Erro ao cadastrar suspensão")
      }
      this.novaSuspensao.cpf = null;
      this.novaSuspensao.nome = null;
      this.novaSuspensao.oab = null;
      this.novaSuspensao.inicioSuspensao = null;
      this.novaSuspensao.fimSuspensao = null;
      this.novaSuspensao.observacao = null;
    },

    async excluirSuspensao(idSuspensao) {
      const response = await suspensaoAdvogadoService.excluirSuspensao(idSuspensao)
      if (response && response.status == 200) {
        await this.loadData()
        this.$toast.success("Suspensão excluída com sucesso")
      }
      else if (response && response.status == 400) {
        response.data.erros.forEach(erro => {
          this.$toast.error(erro, {
            timeout: 10000
          })
        });
      }
      else {
        this.$toast.error("Erro ao excluir suspensão")
      }
      this.novaSuspensao.cpf = null;
      this.novaSuspensao.nome = null;
      this.novaSuspensao.oab = null;
      this.novaSuspensao.inicioSuspensao = null;
      this.novaSuspensao.fimSuspensao = null;
      this.novaSuspensao.observacao = null;
    },

    async editarSuspensao() {
      this.suspensaoEditar.inicioSuspensao.setHours(0);
      this.suspensaoEditar.inicioSuspensao.setMinutes(0);
      this.suspensaoEditar.inicioSuspensao.setSeconds(0);
      if (this.suspensaoEditar.fimSuspensao != null) {
        this.suspensaoEditar.fimSuspensao.setHours(23);
        this.suspensaoEditar.fimSuspensao.setMinutes(59);
        this.suspensaoEditar.fimSuspensao.setSeconds(59);
      }
      const response = await suspensaoAdvogadoService.editarSuspensao(this.suspensaoEditar)
      if (response && response.status == 200) {
        await this.loadData()
        this.fecharModalEdicao()
        this.$toast.success("Suspensão alterada com sucesso")
      }
      else if (response && response.status == 400) {
        response.data.erros.forEach(erro => {
          this.$toast.error(erro, {
            timeout: 10000
          })
        });
      }
      else {
        this.$toast.error("Erro ao obter lista de suspensões")
      }
    },

    async abrirModalEdicao(idSuspensao) {
      const response = await suspensaoAdvogadoService.buscarSuspensao(idSuspensao);
      if (response && response.status == 200) {
        this.suspensaoEditar.id = response.data.IdSuspensao;
        this.suspensaoEditar.cpf = response.data.Cpf;
        this.suspensaoEditar.nome = response.data.Nome;
        this.suspensaoEditar.oab = response.data.Oab;
        this.suspensaoEditar.observacao = response.data.Observacao;
        this.suspensaoEditar.inicioSuspensao = new Date(response.data.DtInicioSuspensao);
        this.suspensaoEditar.fimSuspensao = response.data.DtFimSuspensao ? new Date(response.data.DtFimSuspensao) : null;
      }
      this.$bvModal.show('edit-modal')
    },

    fecharModalEdicao() {
      this.suspensaoEditar.id = null;
      this.suspensaoEditar.cpf = null;
      this.suspensaoEditar.nome = null;
      this.suspensaoEditar.oab = null;
      this.suspensaoEditar.inicioSuspensao = null;
      this.suspensaoEditar.fimSuspensao = null;
      this.suspensaoEditar.observacao = null;
      this.$bvModal.hide('edit-modal')
    },

    abrirModalDetalhes(item) {
      this.suspensaoDetalhes.cpf = item.Cpf;
      this.suspensaoDetalhes.nome = item.Nome;
      this.suspensaoDetalhes.oab = item.Oab;
      this.suspensaoDetalhes.periodoSuspensao = item.PeriodoSuspensao;
      this.suspensaoDetalhes.observacao = item.Observacao;
      this.$bvModal.show('details-modal')
    },

    fecharModalDetalhes() {
      this.suspensaoDetalhes.cpf = null;
      this.suspensaoDetalhes.nome = null;
      this.suspensaoDetalhes.oab = null;
      this.suspensaoDetalhes.periodoSuspensao = null;
      this.suspensaoDetalhes.observacao = null;
      this.$bvModal.hide('details-modal')
    },

    async loadData() {
      let response = await suspensaoAdvogadoService.listarSuspensoes();
      if (response && response.status == 200) {
        this.updateData(response.data)
      }
      else {
        this.$toast.error("Erro ao obter lista de suspensões")
      }

      this.isBusy = false;
    },
    async updateData(data) {
      this.items = data.map((item) => {
        item.PeriodoSuspensao = this.formatData(item.DtInicioSuspensao) + " - " + (item.DtFimSuspensao ? this.formatData(item.DtFimSuspensao) : 'término não definido');
        return item;
      });
    },

    async buscarAdvogadoPorCpf(cpf, operacao) {
      const response = await suspensaoAdvogadoService.buscarAdvogadoPorCpf(cpf)
      if (response && response.status == 200) {
        if (response.data.usuarioEncontrado) {
          this.usuarioEncontradoMsg = response.data.msg
          if (operacao == 'criar') {
            this.novaSuspensao.nome = response.data.nome
            this.novaSuspensao.oab = response.data.oab
          }
          else {
            this.suspensaoEditar.nome = response.data.nome
            this.suspensaoEditar.oab = response.data.oab
          }
        }
        else {
          this.usuarioEncontradoMsg = response.data.msg
          if (operacao == 'criar') {
            this.novaSuspensao.nome = ''
            this.novaSuspensao.oab = ''
          }
          else {
            this.suspensaoEditar.nome = ''
            this.suspensaoEditar.oab = ''
          }
        }
      }
    }
  },
  computed: {
    novaSuspensaoPreenchida() {
      return this.novaSuspensao.cpf && this.novaSuspensao.nome && this.novaSuspensao.oab && this.novaSuspensao.inicioSuspensao;
    },

    suspensaoEditarPreenchida() {
      return this.suspensaoEditar.cpf && this.suspensaoEditar.nome && this.suspensaoEditar.oab && this.suspensaoEditar.inicioSuspensao;
    }
  },
  async mounted() {
    await this.loadData();
    this.totalRows = this.items.length
  },
};
</script>

<style>
.datepicker-sagres>div>.b-form-btn-label-control.dropdown.b-form-datepicker.form-control.show>.dropdown-menu.show {
  position: fixed !important;
  top: inherit !important;
  left: inherit !important;
}
</style>